import { createStore } from '@/utils/createStore'

// Collection status of the receivable this receipt was applied to.
export type PaymentStatus = 'unpaid' | 'partially_paid' | 'paid' | 'tds_deducted' | 'overdue'

// Per-invoice breakdown of a receipt — needed so editing/voiding a payment can
// correctly reverse exactly what was previously applied to each invoice.
export interface PaymentInvoiceApplication {
  invoiceId: string
  invoiceNumber: string
  applied: number
}

export interface PaymentRecord {
  id: string
  receiptNumber: string
  customer: string
  customerId: string
  invoices: PaymentInvoiceApplication[]
  baseAmount?: number        // pre-GST amount
  gstAmount?: number         // GST portion
  amount: number             // gross applied = base + GST
  tds: number                // TDS deducted by the customer
  amountReceived?: number    // Total Amount Received = base + GST − TDS
  mode: string
  date: string
  status: 'confirmed' | 'pending' | 'bounced'  // receipt clearance
  paymentStatus?: PaymentStatus                // collection status of the invoice(s)
  reference?: string         // transaction / UTR number
  // PY-05: TDS & GST certificate proof — reference number plus the uploaded
  // file's URL (object storage key), one pair per certificate.
  tdsCertRef?: string
  tdsCertUrl?: string
  form16a?: string
  form16aAttached?: boolean
  gstCertRef?: string
  gstCertUrl?: string
}

export const paymentStore = createStore<PaymentRecord>('sp_payments', [], 'RCP', 3, '/payments')
